import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">OSINT Fund · Empowering Insight</p>
        <h1>Unlock the Power of Open Source Intelligence</h1>
        <p className="lede">
          At OSINT Fund, we provide you with the tools and resources to harness the potential of open source intelligence. Explore our platform to gain valuable insights and make informed decisions.
        </p>
        <div className="cta-row">
          <a href="https://docs.osintfund.com" target="_blank">
            Learn More
          </a>
          <a href="https://github.com/osintfund" target="_blank" className="secondary">
            Explore Our Projects
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Discover Insights</h2>
          <p>
            Access a wealth of information from diverse sources to enhance your understanding and drive your strategies.
          </p>
        </article>
        <article>
          <h2>Collaborate with Experts</h2>
          <p>
            Join a community of professionals and enthusiasts who share knowledge and best practices in open source intelligence.
          </p>
        </article>
        <article>
          <h2>Stay Ahead of the Curve</h2>
          <p>
            Leverage our tools to stay updated with the latest trends and developments in the world of open source intelligence.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;